import { render, staticRenderFns } from "./RewardDialog.vue?vue&type=template&id=31c591f6&"
import script from "./RewardDialog.vue?vue&type=script&lang=js&"
export * from "./RewardDialog.vue?vue&type=script&lang=js&"
import style0 from "./RewardDialog.vue?vue&type=style&index=0&id=31c591f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports